import React from "react";
import { Doughnut } from "react-chartjs-2";
import style from "./style.module.css";
import { PreloaderSvg } from "../../../preloaderSvg/PreloaderSvg";
import ChartDataLabels from "chartjs-plugin-datalabels";

interface RegionCapacity {
  nameRu: string;
  nameKy: string;
  capacity: number;
  percentage: number;
}
interface CapacityData {
  success: boolean;
  res?: {
    totalCapacity: number;
    regionsData: RegionCapacity[];
  };
}
interface LeftGraphProps {
  data?: { success: boolean; res?: any | undefined };
  isLoading?: boolean;
  year: number;
}

const COLORS = ["#1B7F1B", "#4CD964", "#B6E36C", "#FFD700", "#FFB6B6"];

export const LeftGraph: React.FC<LeftGraphProps> = ({ data, isLoading, year }) => {
  if (isLoading) return <div><PreloaderSvg /></div>;

  const regions = data && Array.isArray(data.res?.regionsData) ? data.res.regionsData : [];
  const total = data && typeof data.res?.totalCapacity === 'number' ? data.res.totalCapacity : 0;

  const chartData = {
    labels: (regions as any[]).map((r: any) => r.nameRu),
    datasets: [
      {
        data: (regions as any[]).map((r: any) => r.capacity),
        backgroundColor: COLORS.slice(0, regions.length),
        borderWidth: 0,
        cutout: "70%",
      },
    ],
  };

  return (
    <div className={style.graphContainer}>
      <div className={style.title}>Параметры мощности ТЛЦ по регионам</div>
      <div className={style.flexRow}>
        <div className={style.doughnutWrapper}>
          <Doughnut
            data={chartData}
            options={{
              plugins: {
                legend: { display: false },
                tooltip: {
                  callbacks: {
                    label: (ctx) =>
                      `${ctx.label}: ${ctx.raw as number} т (${Math.round(
                        (Number(ctx.raw) / total) * 100
                      )}%)`,
                  },
                },
                datalabels: {
                  formatter: (value: any) => `${Number(value).toFixed(1)} т`,
                  color: '#333',
                  font: { weight: 'bold', size: 14 },
                },
              },
            }}
            plugins={[ChartDataLabels]}
          />
          <div className={style.centerText}>{year}</div>
        </div>
        <div className={style.legend}>
          <div className={style.legendTitle}>
            <span className={style.legendGray}>Общий объем</span> – <b>{total.toLocaleString()} т</b>
          </div>
          {regions.map((r: any, i: any) => (
            <div className={style.legendItem} key={r.nameRu}>
              <span className={style.legendDot} style={{ background: COLORS[i % COLORS.length] }} />
              {r.nameRu} – <b>{r.capacity.toLocaleString()} т</b>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};       